<script setup lang="ts">
import { Enums } from "@/enums";
import { computed } from "vue";
import { assertUnhandledStatus } from "../../common/asserts.common";

const props = defineProps<{
    status: Enums.DisbursementStatusEnum.Values;
}>();

const label = computed(() => Enums.DisbursementStatusEnum.label(props.status));
const color = computed(() => {
    switch (props.status) {
        case "P":
            return "bg-blue-500";
        case "S":
            return "bg-green-500";
        case "F":
            return "bg-red-500";
        default:
            return assertUnhandledStatus(props.status);
    }
});
</script>

<template>
    <div class="rns-g-badge" :class="color">{{ label }}</div>
</template>

<style>
@reference "@/styles/main.css";
</style>
